import { render, staticRenderFns } from "./CabinetDashboard.vue?vue&type=template&id=61a850c6&scoped=true&"
import script from "./CabinetDashboard.vue?vue&type=script&lang=ts&"
export * from "./CabinetDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CabinetDashboard.vue?vue&type=style&index=0&id=61a850c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a850c6",
  null
  
)

export default component.exports